import { Button } from '@mui/material';
import { Link } from 'react-router-dom';

const EmailSentView = () => {
  return (
    <>
      <h1 className='font-bold text-[32px] text-[#121212] mb-1'>Forgot Password</h1>
      <p className='text-xl mb-1'>Thank you.</p>
      <p className='text-sm mb-3'>We&apos;ve sent you an email to create a new password. Please check your inbox.</p>
      <Link to='/'>
        <Button
          sx={{
            height: 48,
            fontWeight: 700,
          }}
          type='reset'
          variant='outlined'
          fullWidth
        >
          Go back to Login
        </Button>
      </Link>
    </>
  );
};

export default EmailSentView;
